import { MaterialIcon, Horizontal, GraviButton } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import * as React from 'react'
import type { ActionButtonsProps } from '../types'

/**
 * Component for rendering action buttons in the surcharge grid
 */
export function ActionButtons({ params, onEdit, onViewRateHistory }: ActionButtonsProps) {
  return (
    <Horizontal
      gap={4}
      style={{
        display: 'flex',
        justifyContent: 'center',
        overflow: 'visible',
      }}
    >
      <Tooltip title='Edit'>
        <GraviButton
          icon={<MaterialIcon size={16} className='pt-1' icon='edit' />}
          onClick={(e) => {
            e.stopPropagation()
            if (params.data) {
              onEdit(params.data)
            }
          }}
        />
      </Tooltip>
      <Tooltip title='View Rate History'>
        <GraviButton
          icon={<MaterialIcon size={16} className='pt-1' icon='overview' />}
          onClick={() => {
            if (params.data) {
              onViewRateHistory(params.data)
            }
          }}
        />
      </Tooltip>
    </Horizontal>
  )
}
